import PDF from './pdf'
import { capitalizeFirstLetter } from '../lib/utils'

export default class CollectiblesReport extends PDF {
  /**
   * Description
   * @param {import('jspdf').DocumentProperties} args
   */
  constructor(args = {}) {
    super()
    this.doc.setProperties({
      unit: 'mm',
      format: 'a4',
      ...args,
    })
    this.addFonts()
  }

  /**
   * Description
   * @param {HeadingData} data
   */
  __header({ storeName = '', asOf = '' }) {
    const title = `${capitalizeFirstLetter(storeName)} Collectibles Report`
    this.centerText({ fontSize: 24, text: title, yOffset: 15, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: 'Outstanding Balances per Receipt', yOffset: 22, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: `As of ${asOf}`, yOffset: 27 })
    this.doc.setFillColor('#CFD8DC')
    this.doc.line(15, 30, 195, 30, 'F')
  }

  /**
   * Description
   * @param {HeadingData} subHeader
   * @returns {void}
   */
  __subHeader(subHeader) {
    const { totalReceivable = '', totalPaid = '', totalBalance = '' } = subHeader || {}
    const [x, y] = [15, 40]
    const delimiter = ':'

    const { labelWidth: textLength } = this.generateField({
      label: 'Total Receivable',
      value: totalReceivable,
      coordinates: [x, y],
      lineLength: 0,
      delimiter,
    })

    this.generateField({
      label: 'Total Paid',
      value: totalPaid,
      coordinates: [x, y + 5],
      textLength,
      lineLength: 0,
      delimiter,
    })

    this.generateField({
      label: 'Total Balance',
      value: totalBalance,
      coordinates: [x, y + 10],
      textLength,
      lineLength: 0,
      delimiter,
    })
  }

  /**
   * Description
   * @param {HeadingData} _
   * @param {ReportRow[]} body
   * @returns {any}
   */
  __table(_, body) {
    this.doc.autoTable({
      head: [['Receipt#', 'Name', 'Due', 'Date', 'Amnt', 'Balance', 'Paid', 'Last Paid']],
      startY: 60,
      body: [
        ...body,
      ],
    })
  }

  /**
   * Description
   * @param {string} storeName
   * @returns {void}
   */
  __save(storeName) {
    const name = `${storeName}_collectibles_report_${new Date().getTime()}`.replace(/[\s]+/g, '_')
    this.doc.save(name)
  }

  /**
   * Description
   * @param {HeadingData} data
   * @param {ReportRow[]} items
   * @returns {any}
   */
  generate(data, items) {
    this.__header(data)
    this.__subHeader(data)
    this.__table(data, items)
    this.__save(data.storeName)
  }
}

/**
 * @typedef HeadingData
 * @property {string} storeName
 * @property {string} asOf
 * @property {string} totalReceivable
 * @property {string} totalPaid
 * @property {string} totalBalance
 *
 * @typedef {Array<{ content: string|number, styles?: object }>} ReportRow
 */
